import { Layout, LayoutProps } from 'antd';
import React from 'react';

import styles from './PageContent.module.css';

const PageContent: React.FC = (props: LayoutProps) => {
  return <Layout.Content className={styles.content} {...props} />;
};

export default PageContent;
